"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Panel = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const string_1 = require("../../helpers/string/string");
const Panel_styled_1 = require("./Panel.styled");
const Panel = ({ children, className }) => (0, jsx_runtime_1.jsx)(Panel_styled_1.PanelStyled, { className: (0, string_1.getClassName)('octo', className), children: children });
exports.Panel = Panel;
//# sourceMappingURL=Panel.js.map